import { createApp } from 'vue'
import App from './App.vue'
// import VConsole from 'vconsole'

// new VConsole()

const app = createApp(App)
app.mount('#app')
